// @flow

import * as React from "react";
import { Form } from "react-final-form";

import Button from "../../components/Button";
import Card from "../../components/Card";
import FieldControl from "../../components/FieldControl";
import { FlashMessageConsumer } from "../../components/FlashMessages";
import FormRow from "../../components/FormRow";
import PageHeader from "../../components/PageHeader";
import PageLayout from "../../components/PageLayout";
import TextInput from "../../components/Input/TextInput";

import { requestPasswordReset } from "../../api/actions";
import * as validators from "../../utils/validators";
import { errors } from "../../utils/errors";

import styles from "./ForgottenPassword.scss";
import { isFormSubmitting } from "../../utils/helpers";

type ForgottenPasswordState = {
  requestSent: boolean
};

const EMAIL = "email";

class ForgottenPassword extends React.Component<{}, ForgottenPasswordState> {
  state = {
    requestSent: false
  };

  submitForm =
    (addMessage: (React.Node, "success" | "failure") => void) => (values: { email: string }) =>
      requestPasswordReset(values)
        .then(() => {
          this.setState({ requestSent: true });
        })
        .catch(() => {
          addMessage(
            "Beim Zurücksetzen Ihres Passworts ist ein Fehler aufgetreten. Bitte versuchen Sie es noch einmal.",
            "failure"
          );
        });

  render() {
    const { requestSent } = this.state;
    return (
      <PageLayout>
        <PageHeader header="Passwort zurücksetzen" bottomMargin />
        <Card>
          {requestSent ? (
            <header>
              Vielen Dank! Sie erhalten eine E-Mail mit weiteren Informationen. Schauen Sie auch in
              Ihrem Spam-Ordner.
            </header>
          ) : (
            <>
              <header>
                Bitte geben Sie Ihre E-Mail-Adresse ein und klicken Sie auf &quot;Passwort
                zurücksetzen&quot;. Im Anschluss erhalten Sie eine E-Mail mit weiteren
                Informationen.
              </header>
              <FlashMessageConsumer>
                {({ addMessage }) => (
                  <Form onSubmit={this.submitForm(addMessage)}>
                    {({ form }) => (
                      <form onSubmit={() => false}>
                        <FormRow>
                          <div className={styles.halfField}>
                            <FieldControl
                              name={EMAIL}
                              caption={() => "E-Mail"}
                              validate={validators.combineValidators(
                                validators.required(errors.requiredField()),
                                validators.isEmail(errors.isEmailCorrect())
                              )}
                            >
                              {({ input }) => <TextInput input={input} placeholder="Ihre E-Mail" />}
                            </FieldControl>
                          </div>
                        </FormRow>
                        <Button
                          data-testid="password-reset-button"
                          isDisabled={!form.getState().valid || isFormSubmitting(form)}
                          onClick={form.submit}
                        >
                          Passwort zurücksetzen
                        </Button>
                      </form>
                    )}
                  </Form>
                )}
              </FlashMessageConsumer>
            </>
          )}
        </Card>
      </PageLayout>
    );
  }
}

export default ForgottenPassword;
